/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { TBookingRequest, TUser } from '../../../../types';

export type TBasicRates = {
    freelancer_pay_per_hour: number | string;
    client_pay_per_hour: number | string;
};

export type TAgentRateProps = {
    bookingRequest: TBookingRequest;
    user: TUser;
    basicRates: TBasicRates;
    setBasicRates: any;
    mode: string;
    showValidation?: boolean;
};

export function isValidPayRate(value: number | string | null | undefined): boolean {
    if (value === '' || value === null || value === undefined) {
        return false;
    }
    const num = Number(value);
    return !Number.isNaN(num) && Number.isFinite(num);
}

export default function AgentRate({
    bookingRequest,
    user,
    basicRates,
    setBasicRates,
    mode,
    showValidation = false,
}: TAgentRateProps) {
    const canEditRates = mode !== 'edit' || bookingRequest.managed;
    const showClientRate = !user.agency.features.includes('self_managed');
    const workerRateInvalid =
        showValidation && !isValidPayRate(basicRates.freelancer_pay_per_hour);
    const clientRateInvalid =
        showValidation && showClientRate && !isValidPayRate(basicRates.client_pay_per_hour);

    useEffect(() => {
        if (mode !== 'create') {
            setBasicRates({
                freelancer_pay_per_hour: bookingRequest.freelancer_pay_per_hour ?? '',
                client_pay_per_hour: bookingRequest.client_pay_per_hour ?? '',
            });
        }
    }, [bookingRequest.freelancer_pay_per_hour, bookingRequest.client_pay_per_hour]);

    const handleOnChange = (event: any, fieldName: string) => {
        const newState = {
            ...basicRates,
            [fieldName]: event.target.value === '' ? '' : Number(event.target.value),
        };
        setBasicRates(newState);
    };

    return (
        <div className="agent-rates">
            <div className="flex-display flex-display--start shift-form-row-wrap">
                <div
                    className={classNames(
                        'shift-form-field shift-form-field--half small-margin-bottom',
                        { invalid: workerRateInvalid },
                    )}
                >
                    <label htmlFor="freelancer_pay_per_hour">Workers rate</label>
                    <input
                        type="number"
                        step="0.25"
                        id="freelancer_pay_per_hour"
                        data-testid="freelancerPayInput"
                        value={basicRates.freelancer_pay_per_hour ?? ''}
                        onChange={event => {
                            handleOnChange(event, 'freelancer_pay_per_hour');
                        }}
                        disabled={!canEditRates}
                    />
                </div>
                {showClientRate && (
                    <div
                        className={classNames(
                            'shift-form-field shift-form-field--half small-margin-bottom',
                            { invalid: clientRateInvalid },
                        )}
                    >
                        <label htmlFor="client_pay_per_hour">Client rate</label>
                        <input
                            type="number"
                            step="0.25"
                            id="client_pay_per_hour"
                            data-testid="clientPayInput"
                            value={basicRates.client_pay_per_hour ?? ''}
                            onChange={event => {
                                handleOnChange(event, 'client_pay_per_hour');
                            }}
                            disabled={!canEditRates}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
